var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.row ? 'd-flex' : ''},[(_vm.labeltxt != null)?_c('div',{staticClass:"ml-2 mb-2 label",class:_vm.row ? 'label-row' : ''},[_c('label',{domProps:{"innerHTML":_vm._s(_vm.htmlLabeltxt)}})]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }